import { createBrowserHistory } from "history";
// @TODO: maybe delete this whole service... did not notice anything new / better compared to useHistory...
export const history = createBrowserHistory();
